module.exports = __webpack_public_path__ + "img/discovery-loader.16e96cd0.svg";